






















































































































































import { Vue, Component } from 'vue-property-decorator';
import Slideshow from '@/components/brand/brand_center/SlideshowView.vue';
import ScheduleMeetingDialog from '@/components/brand/ScheduleMeetingDialog.vue';
import { videoPlayer } from 'vue-video-player';
import BrandSectionCard from '@/components/common/BrandSectionCard.vue';
import BrandProductCard from '@/components/brand/BrandProductCard.vue';
import { HOME_SLIDER } from '../../common/brand.config';
import brandModule from '../../store/modules/brand.module';
import 'video.js/dist/video-js.css';
import {
  ASSET_URL,
  BRAND_BOOK_ID,
  VIDEO_ID,
} from '../../common/config';
import { BRAND_CENTER_PAGE, BRAND_PRODUCT_PAGE, VIDEO_VAULT_PAGE } from '../../common/routes.config';
import BrandAsset from '../../common/model/BrandAsset';
import Product from '../../common/model/Product';
import productModule from '../../store/modules/product.module';

@Component({
  components: {
    Slideshow,
    ScheduleMeetingDialog,
    videoPlayer,
    BrandSectionCard,
    BrandProductCard,
  },
})
export default class HomePage extends Vue {
  HOME_SLIDER = HOME_SLIDER;

  cdnUrl = ASSET_URL;

  commonVideoOptions: any = { height: '450px' };

  BRAND_CENTER = BRAND_CENTER_PAGE;

  get brandSecondaryColor(): string {
    if (!brandModule.brand || !brandModule.brand.secondary_color) {
      return '#000000';
    }
    return brandModule.brand.secondary_color;
  }

  get brandDescription(): string {
    if (!brandModule.brand || !brandModule.brand.description) { return ''; }
    return brandModule.brand.description;
  }

  get brandProducts(): Array<Product> {
    return productModule.products;
  }

  get brandLogo(): string {
    if (!brandModule.brand) { return ''; }
    return `${this.cdnUrl}${brandModule.brand.logo}`;
  }

  get colorPalette(): Array<string> {
    if (!brandModule.brand) {
      return [];
    }
    return brandModule.brand.color_palette;
  }

  get brandHeader(): string {
    if (!brandModule.brand) { return 'Welcome.'; }
    if (!brandModule.brand.header) { return `Welcome to ${brandModule.brand.name}` }
    return brandModule.brand.header;
  }


  get brandBook(): BrandAsset | undefined {
    if (!brandModule.brand || !brandModule.brand.brand_assets) {
      return;
    }
    const brandBook = brandModule.brand.brand_assets.filter((asset) => {
      if (!asset.category) {
        return false;
      }
      return asset.category.id === BRAND_BOOK_ID;
    });
    return brandBook[0];
  }

  get brandName(): string {
    if (!brandModule.brand) {
      return '';
    }
    return brandModule.brand.name;
  }

  get announcement(): string {
    if (!brandModule.brand || !brandModule.brand.announcement) {
      return '';
    }
    return brandModule.brand.announcement;
  }

  get featuredAssets(): Array<BrandAsset> {
    if (!brandModule.brand || !brandModule.brand.brand_assets) {
      return [];
    }
    const featuredAssets = brandModule.brand.brand_assets.filter(
      asset => asset.featured,
    );
    if (featuredAssets.length > 3) {
      return featuredAssets.splice(0, 3);
    }
    return featuredAssets;
  }

  get latestBrandVideo(): BrandAsset | undefined {
    if (!brandModule.brand) {
      return;
    }
    if (!brandModule.brand.brand_assets) {
      return;
    }
    const brandVideos = brandModule.brand.brand_assets.filter((asset) => {
      if (!asset.category) {
        return;
      }
      return asset.category.id === VIDEO_ID;
    });
    this.onResize();
    return brandVideos[0];
  }

  onResize(): void {
    const cardElement: any = document.querySelector('#video-feature');
    console.log(cardElement);
    if (!cardElement) {
      this.commonVideoOptions = { width: 700 };
      return;
    }
    const width = cardElement.offsetWidth;
    this.commonVideoOptions = { width };
  }

  async mounted(): Promise<void> {
    this.commonVideoOptions.height = '400px';
    await new Promise(resolve => setTimeout(resolve, 3000));
    this.onResize();
  }

  created(): void {
    window.addEventListener('resize', this.onResize);
  }

  toBrandAsset(): void {
    this.$router.push(BRAND_CENTER_PAGE);
  }

  toProductPage(): void {
    this.$router.push(BRAND_PRODUCT_PAGE);
  }

  toVideoVault(): void {
    this.$router.push(VIDEO_VAULT_PAGE);
  }
}
